import {Grid} from "@mui/material";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import {
  displayDay, displayEventTime,
  formatCurrency, formatDateTimeTz,
  inventoryAvailable, maxMatrixPrice,
  validEvent
} from "../../common/Utils";
import React, {useContext, useEffect, useState} from "react";
import {CalendarIcon} from "@mui/x-date-pickers";
import Link from "@mui/material/Link";
import EventRegistration from "./EventRegistration";
import PlaceIcon from "@mui/icons-material/Place";
import {CompanyContext} from "../../../lib/CompanyProvider";
import {CardMembership, EventRepeat, PersonOutline, Sell, InfoOutlined} from "@mui/icons-material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";

export default function EventDetail({event, children, showDesc, full, showRegistration, embedded, packages, callback}) {
  const [companyContext, setCompanyContext] = useContext(CompanyContext);

  const [company, setCompany] = useState();
  useEffect(() => {
    setCompany(companyContext)
  }, [companyContext]);

  const showAttendees = (event, embedded) => {
    if (event?.eventType?.hideAttendees) {
      return false;
    }
    if (embedded) {
      return true;
    }
    if (event?.timeBlockParent) {
      return false;
    }
    return true;
  }

  const eventDetail = (event, full, showDesc, showRegistration, embedded, callback) => {
    return (
      <Grid item xs={12} sm={9}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2} md={3}>
            {event?.imageUrl ? <img
              style={{
                maxWidth: '95%',
                height: 'auto'
              }}
              alt={event.name}
              src={event?.imageThumbUrl || event?.imageUrl}
            /> : <>&nbsp;</>
            }
          </Grid>
          <Grid item xs={12} sm={10} md={9}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <MDBox>
                  <h2>
                    <Link href={'#/cx/register/' + event.guid}>{event.name}</Link>
                  </h2>
                </MDBox>


                {!event.sessionEvent && <MDBox>
                  <p>
                    <small>
                      <CalendarIcon/>&nbsp;Event Date:
                      <>
                        {companyContext?.timeZone && !embedded && event.timeBlockParentGuid?.length > 0 && <>
                          <b>&nbsp;{formatDateTimeTz(event.eventDate, 'dddd, MMMM Do, YYYY', companyContext.timeZone)} - Multiple
                            times</b>
                        </>}
                        {(embedded || !(event.timeBlockParentGuid?.length > 0)) && <>
                          {event.allDay && <b>&nbsp;All Day</b>}
                          {companyContext?.timeZone && !event.allDay &&
                            <b>&nbsp;{displayEventTime(event, companyContext?.timeZone, 'dddd, MMMM Do, YYYY h:mm a')}</b>}
                        </>}
                      </>
                    </small>
                  </p>
                </MDBox>}
                {event.sessionEvent && <>
                  <p>
                    <small>
                      Session Event Times
                    </small>
                  </p>
                  {event.sessionEvents.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                    .map((a, idx) => {
                      return (
                        <MDBox key={idx}>
                          <MDTypography variant="p" fontWeight="regular" color="secondary">
                            Event Date: <b>{displayDay(a.eventDate, 'dddd, MMMM Do, YYYY h:mm a')}</b>
                          </MDTypography>
                        </MDBox>
                      )

                    })
                  }
                </>}
                {event?.eventLocation?.name && <>
                  <p><small><PlaceIcon/>&nbsp;
                    {event?.eventLocation?.name ? event?.eventLocation?.name : ' '}
                    {(event?.eventLocation?.name && companyContext?.displayLocation ? '- ' : '')}
                    {companyContext?.displayLocation}
                  </small>
                  </p>
                </>
                }
                {!event?.eventType?.specialEvent && <>
                  <p><small>
                    Age: {event.ageRange?.name}
                  </small>
                  </p>
                  {showAttendees(event, embedded) && <p><small>
                    Space available: {inventoryAvailable(event)}
                  </small>
                  </p>}
                </>
                }
                <div>
                  <p><small><PersonOutline/> {event.eventType?.name}</small></p>

                  {event?.eventType?.memberOnly &&
                    <>
                      <p><small><CardMembership/> Membership Required</small></p>
                    </>
                  }

                  {showDesc && !event?.eventType?.memberOnly && !event?.eventType?.eventTypeInformational &&
                    <>
                      {!event?.eventMatrix && parseInt(event?.price, 10) > 0 && <p>
                        <small><Sell/> {(event?.packageRequired ? 'Starting ' : '') + 'Price: ' + formatCurrency(event.price)}
                        </small>
                      </p>
                      }
                      {event?.eventMatrix &&
                        <p><small><Sell/> Price: {formatCurrency(maxMatrixPrice(event))}</small></p>
                      }
                    </>
                  }

                  {event?.sessionEvent &&
                    <>
                      <p><small><EventRepeat/> Session Event</small></p>
                    </>
                  }

                  {!event?.eventType?.eventTypeInformational && !validEvent(event, 'details') &&
                    <>
                      <p>
                        <small><InfoOutlined/> Registration closed</small></p>
                    </>
                  }

                  {event?.reservationStatus?.id > -1 && !(full || showRegistration) &&
                    <p>
                      <TipsAndUpdatesIcon/>
                      &nbsp;You are already registered for this event</p>
                  }
                </div>

                {showDesc && <MDBox my={2}>
                  <div style={{
                    clear: 'both',
                    marginTop: '10px',
                    whiteSpace: 'pre-wrap',
                    fontSize: '0.875rem',
                    marginBottom: '20px'
                  }}>
                    {event?.desc}
                    {/*<ToggleDetails text={event?.desc} limit={15}/>*/}
                  </div>

                </MDBox>
                }

                {children}

                {!event?.eventType?.eventTypeInformational && <>
                  {(full || showRegistration) && <>
                    <EventRegistration
                      full={full}
                      showRegistration={showRegistration}
                      embedded={embedded}
                      callback={() => {
                        callback('close')
                      }}
                      event={event}/>
                  </>
                  }
                </>}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    )
  }

  return (
    <>
      {companyContext?.timeZone && event && eventDetail(event, full, showDesc, showRegistration, embedded, callback)}
    </>
  )
}